<div *ngIf = "mailResponse" class="wrap">
  <header>
    <p>
      {{mailResponse.title}}
    </p>
  </header>
  <div class="welcome-message">
    <p>{{mailResponse.message}}</p>
  </div>

  <!-- <a href={{loginPage}} class="back-to-orbitax">
    <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
    <span>Back to Orbitax</span>
  </a> -->
</div>

<!--<div class="wrap">
  <header>

    <p *ngIf="isFailed === false">
      Success!
    </p>
    <p *ngIf="isFailed === true">
      Failed!
    </p>
  </header>
  <div class="welcome-message">
    <p *ngIf="isFailed === false">Thank you. You have confirmed receipt of the notification email successfully.</p>
    <p *ngIf="isFailed === true">Sorry. Invalid code.</p>
  </div>

  <a href={{loginPage}} class="back-to-orbitax">
    <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
    <span>Back to Orbitax</span>
  </a>
</div>-->
